import * as React from 'react';
import 'fontsource-roboto';
import '../app.css';
import {
  Button,
  Dialog, DialogActions, DialogContent, DialogTitle,
  Grid,
  Typography,
} from '@material-ui/core';
import ChipSelect from '../ChipSelect';

interface ImproperlyPackedDialogProps {
  trackingNumber: string;
  showModal: boolean;
  onClose: (value?: Array<string>) => void;
}

const ImproperlyPackedDialog: React.FC<ImproperlyPackedDialogProps> = (
  { trackingNumber, showModal, onClose },
) => {
  const reasonText: Record<string, string> = {
    outerBag: 'Wrong outer bag',
    innerSecurity: 'No inner security',
    innerPack: 'No inner padded pack',
    plainCardboard: 'Shipped in plain cardboard',
  };
  const [improperlyPackedReasons, setImproperlyPackedReasons] = React.useState(Array<string>());

  const handleCancel = () => {
    setImproperlyPackedReasons(Array<string>());
    onClose();
  };
  const handleSave = () => {
    onClose(improperlyPackedReasons);
  };

  const handleReasonChange = (reason: string) => {
    const reasons = [...improperlyPackedReasons];
    const index = reasons.indexOf(reason);

    if (index === -1) {
      reasons.push(reason);
    } else {
      reasons.splice(index, 1);
    }

    setImproperlyPackedReasons(reasons);
  };

  return (
    <Dialog onClose={handleCancel} open={showModal}>
      <DialogTitle>
        <Typography variant="overline">
          {'CURRENT BOX · #'}
          {trackingNumber}
        </Typography>
        <Typography variant="h5" id="dialog-header">{'How is the box improperly packed?'}</Typography>
        <Typography variant="body2" color="textSecondary">
          {'Please choose the reason(s) why this box wasn’t packed correctly'}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={1}>
          <Grid item>
            <ChipSelect
              label={reasonText.outerBag}
              selected={improperlyPackedReasons.includes(reasonText.outerBag)}
              handleClick={() => handleReasonChange(reasonText.outerBag)}
            />
          </Grid>
          <Grid item>
            <ChipSelect
              label={reasonText.innerSecurity}
              selected={improperlyPackedReasons.includes(reasonText.innerSecurity)}
              handleClick={() => handleReasonChange(reasonText.innerSecurity)}
            />
          </Grid>
          <Grid item>
            <ChipSelect
              label={reasonText.innerPack}
              selected={improperlyPackedReasons.includes(reasonText.innerPack)}
              handleClick={() => handleReasonChange(reasonText.innerPack)}
            />
          </Grid>
          <Grid item xs={12}>
            <ChipSelect
              label={reasonText.plainCardboard}
              selected={improperlyPackedReasons.includes(reasonText.plainCardboard)}
              handleClick={() => handleReasonChange(reasonText.plainCardboard)}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button color="secondary" variant="text" onClick={handleCancel}>{'CANCEL'}</Button>
        <Button color="primary" variant="contained" disabled={!(improperlyPackedReasons && improperlyPackedReasons.length > 0)} onClick={handleSave}>{'SAVE UPDATES'}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ImproperlyPackedDialog;
